import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { type WalletConnectedData } from '@pkg/types';

export interface WalletStoreData {
    connectedWallets: WalletConnectedData[];
}

export interface WalletStoreState extends WalletStoreData {
    addWallet: (wallets: WalletConnectedData) => void;
    removeWallets: (...wallets: string[]) => void;
    clearWallets: () => void;
}

const initialState: WalletStoreData = {
    connectedWallets: [],
};

export const STORE_KEY_WALLET = 'wallet-store';

export const useWalletStore = create<WalletStoreState>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                addWallet: (walletToAdd) => {
                    set((state) => {
                        const filteredWallets = state.connectedWallets.filter(
                            (wallet) => walletToAdd.walletAddress !== wallet.walletAddress,
                        );
                        return { connectedWallets: [...filteredWallets, walletToAdd] };
                    });
                },
                removeWallets: (...walletsToRemove) =>
                    set((state) => ({
                        connectedWallets: state.connectedWallets.filter(
                            (entry) => !walletsToRemove.includes(entry.walletAddress),
                        ),
                    })),
                clearWallets: () => set({ connectedWallets: [] }),
            }),
            { name: STORE_KEY_WALLET },
        ),
    ),
);
